import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import moment from "moment";
import { WorkdayReportService } from "../../../../modules/workday-report/workday-report.service";
import { UserService } from "../../../../auth/service";

@Component({
  selector: "app-report-unlock-status",
  templateUrl: "./report-unlock-status.component.html",
  styleUrls: ["./report-unlock-status.component.scss"],
})
export class ReportUnlockStatusComponent implements OnInit {
  public month: string = moment().format("MMMM");

  public lastDayCurrentMonth: any = moment().endOf("month").format("DD");

  public previousReports: any = [];

  public report: any = null;

  public myProfile: any;

  public lockReport: boolean = true;

  public unlockDay: any; //Viene fillato con i giorni in cui il report sarà sbloccato

  public unlockStaffDate: string = null;

  public daysUnlockReport: any = 5;

  public available_working_days: Array<number> = [];

  public currentDay: any = moment().format("DD MMMM");

  constructor(
    public _utilService: UtilsService,
    public _workdayReport: WorkdayReportService,
    private _userService: UserService,
  ) {
    this.available_working_days = this._utilService.themeConfiguration.working_days; //Parametro gestito da configurazione per i giorni lavorativi
    this.daysUnlockReport = this._utilService.themeConfiguration.days_unlock_report;
  }

  async ngOnInit() {
    this.myProfile = await this._userService.getMe();
    this.previousReports = await this._workdayReport.getMineReports();
    this.previousReports = this.previousReports.sort((a, b) => (a.id < b.id ? 1 : -1));
    this.report = this.previousReports.find((report) => report.month == moment().format("MM") && report.year == moment().format("YYYY"));

    //Controllo se ci sono dimissioni o licenziamenti il rapportino viene sbloccato subito a inizio mese
    if (this.myProfile.closed_at && this.myProfile.closed_at.length > 0 && moment(this.myProfile.closed_at).format("MM/YYYY") === moment().format("MM/YYYY")) {
      this.lockReport = false;
      return false;
    }
    //Controllo la data di fine contratto il rapportino viene sbloccato subito a inizio mese
    if (this.myProfile.contract_end_date && this.myProfile.contract_end_date.length > 0 && moment(this.myProfile.contract_end_date).format("MM/YYYY") === moment().format("MM/YYYY")) {
      this.lockReport = false;
      return false;
    }

    const reportDateMax = this._utilService.themeConfiguration.user_report_max_day; //Oggetto contente per ogni mese la data di sblocco
    const currentMonth = moment().month();
    const currentDay = moment().format("DD");

    //Controllo data dinamica se è a zero entreremo nell'else e calcoleremo la data di sblocco negli ultimi sette giorni lavorativi
    if (reportDateMax && reportDateMax[currentMonth] > 0) {
      this.unlockStaffDate = String(reportDateMax[currentMonth]) + " " + moment().format("MMMM");
      if (Number(currentDay) < reportDateMax[currentMonth]) {
        this.lockReport = true;
      } else {
        this.lockReport = false;
      }
      this.unlockDay = moment().date(reportDateMax[currentMonth]);
    } else {
      let array: any = [];
      for (let i = this.lastDayCurrentMonth - 14; i <= this.lastDayCurrentMonth; i++) {
        const date: any = moment(i + "/" + moment().format("MM/YYYY"), "D/MM/YYYY");
        const isWeekEnd: boolean = !this.available_working_days.includes(Number(date.format("d")));
        const isHoliday: boolean = this._utilService.isHoliday(date);
        if (array.length < 14 && !isWeekEnd && !isHoliday) {
          array.push(date);
        }
      }
      this.unlockDay = array[array.length - this.daysUnlockReport];
      /*daysUnlockReport parametro gestito dallo staff
            in configurazioni, ad esempio il suo valore è cinque, sara possibile inviare il rapportino cinque giorni lavorativi prima della fine del mese corrente*/
      this.lockReport = moment().subtract(1, "days").diff(this.unlockDay, "day") < 0;
    }
  }
}
